<template>
  <div class="short-answer-container">
    <div class="question-stem">{{question.Question}}</div>
    <div class="helper-text">{{question.HelperText}}</div>
    <div class="answer-choices">
      <div class="answer-choice">
        <div class="radio-button" value="Strongly Agree" type="radio">
          <div class="checked" v-if="questionResponse === 'Strongly Agree'"></div>
        </div>
        <div :name="question.QuestionID" class="answer-choice-label">Strongly Agree</div>
      </div>
      <div class="answer-choice">
        <div class="radio-button" :name="question.QuestionID" value="Agree" type="radio">
          <div class="checked" v-if="questionResponse === 'Agree'"></div>
        </div>
        <div class="answer-choice-label">Agree</div>
      </div>
      <div class="answer-choice">
        <div :name="question.QuestionID" class="radio-button">
          <div class="checked" v-if="questionResponse === 'Neutral'"></div>
        </div>
        <div class="answer-choice-label">Neutral</div>
      </div>
      <div class="answer-choice">
        <div :name="question.QuestionID" class="radio-button">
          <div class="checked" v-if="questionResponse=== 'Disagree'"></div>
        </div>
        <div class="answer-choice-label">Disagree</div>
      </div>
      <div class="answer-choice">
        <div :name="question.QuestionID" class="radio-button">
          <div class="checked" v-if="questionResponse=== 'Strongly Disagree'"></div>
        </div>
        <div class="answer-choice-label">Strongly Disagree</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    selectedTeacher: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      teacher: this.selectedTeacher || { EmployeeId: "", responses: [] },
      questionResponse: `No Answer`
    };
  },
  mounted() {
    this.questionResponse =
      this.teacher.responses.filter(
        ({ QuestionID }) => QuestionID === this.question.QuestionID
      )[0] || `No Answer`;
  }
};
</script>

<style scoped>
.question-stem {
  font-family: Arial;
  font-size: 1em;

  text-align: justify;
  color: #000000;
  margin-bottom: 0.5em;
  line-height: 1.2;
}
.short-answer-container {
  margin-bottom: 3.5em;
  margin-left: 1em;
}
.answer {
  height: 1.25em;
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #979797;
  border-bottom: 1px solid grey;
  width: 90%;
  padding: 0.25em;
}
.answer-choice {
  display: flex;
  padding: 0.25em;
}
.answer-choice-label {
  font-family: Arial, Helvetica, sans-serif;
}
.radio-button {
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin-right: 0.15em;
  border: solid 1px #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checked {
  width: 0.75em;
  height: 0.75em;
  border-radius: 50%;
  background-color: #2c557d;
}
@media only screen and (min-width: 1200px) {
  .question-stem {
    font-family: Arial;
    font-size: 1.25em;
    text-align: justify;
    color: #000000;
    margin-bottom: 0.5em;
    line-height: 1.2;
  }
  .answer-choice {
    display: flex;
    padding: 0.25em;
    font-size: 1.1em;
  }
}
</style>